function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../../../_snowpack/pkg/react.js';
import { useDrag } from '../../../../../_snowpack/pkg/react-dnd.js';
import { Link } from '../../../../../_snowpack/pkg/react-router-dom.js';
import cloneDeep from '../../../../../_snowpack/pkg/lodash/cloneDeep.js';
import dndTypes from '../../../dnd-types.js';
import WebhookIcon from '../../../../icons/svg/webhooks.svg';
import ShapeIcon from '../../../../icons/svg/shapes.svg';
import TopicIcon from '../../../../icons/svg/topics.svg';
import GridIcon from '../../../../icons/svg/grid-green.svg';
import Media from '../../../../icons/svg/media.svg';
import { ListItem } from './styles.js';

function getTypeIcon(type) {
  switch (type) {
    case 'folder':
    case 'product':
    case 'document':
      return Media;

    case 'grid':
      return GridIcon;

    case 'shape':
      return ShapeIcon;

    case 'webhook':
      return WebhookIcon;

    case 'topic':
      return TopicIcon;

    default:
      return Media;
  }
}

function Item(props) {
  const {
    node,
    index,
    getItemProps,
    selectedItem
  } = props;
  const item = cloneDeep(node);
  const [{
    isDragging
  }, drag] = useDrag({
    type: dndTypes.TREE_ITEM,
    item: {
      itemId: node.id,
      item
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  const isCatalogueItem = ['product', 'folder', 'document'].includes(node.type);
  const opacity = isDragging ? 0 : 1;
  return /*#__PURE__*/React.createElement(ListItem, _extends({}, getItemProps({
    item: node,
    index,
    isSelected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === node.id
  }), {
    ref: isCatalogueItem ? drag : null,
    style: {
      opacity
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: node.path
  }, /*#__PURE__*/React.createElement("img", {
    src: getTypeIcon(node.type),
    alt: node.name
  }), /*#__PURE__*/React.createElement("p", {
    title: node.name
  }, node.name, /*#__PURE__*/React.createElement("small", null, node.path))));
}

export default Item;